var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagingCombinedArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    fill: "#F5F5F7",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 14C1.2 14 .5 13.3.5 12.25V1.75C.5.7 1.2 0 2.25 0c.525 0 .875.175 1.225.525L10.3 5.6c.35.35.7.875.7 1.4 0 .525-.35 1.05-.875 1.4L3.3 13.65c-.35.175-.7.35-1.05.35z",
    fill: "inherit"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMSAxNCIgZmlsbD0iI0Y1RjVGNyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjI1IDE0QzEuMiAxNCAwLjUgMTMuMyAwLjUgMTIuMjVMMC41IDEuNzVDMC41IDAuNyAxLjIgMCAyLjI1IDBDMi43NzUgMCAzLjEyNSAwLjE3NSAzLjQ3NSAwLjUyNUwxMC4zIDUuNkMxMC42NSA1Ljk1IDExIDYuNDc1IDExIDdDMTEgNy41MjUgMTAuNjUgOC4wNSAxMC4xMjUgOC40TDMuMyAxMy42NUMyLjk1IDEzLjgyNSAyLjYgMTQgMi4yNSAxNFoiIGZpbGw9ImluaGVyaXQiLz4KPC9zdmc+Cg==";
export { SvgPagingCombinedArrow as ReactComponent };